import React from 'react';
import Icon from './icon';
import './header.css';

const Header = (props) => {

  const caption = props.caption ? 'caption' : ''
  const prominent = props.prominent ? 'prominent' : ''
  const dense = props.dense ? 'dense' : ''
  let theme = props.primary ? 'primary' : ''
  theme = props.secondary ? 'secondary' : theme
  let icon = props.icon ? <Icon {...props.icon} /> : ''
  icon = props.iconSrc ? <img className="header-icon" src={props.iconSrc} /> : icon;

  const style = props.img ? { backgroundImage: `url(${props.img })` } : {}

  return (
    <header className={`header ${caption} ${prominent} ${dense} ${theme} ${props.className}`} style={style}>
      {icon}
      <label>{props.title}</label>
      <span className="actions">{props.children}</span>
    </header>
  )
}

export default Header;



// WEBPACK FOOTER //
// ./src/lib/components/header.js